import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import Categories from './pages/Categories';
import Policies from './pages/Policies';
import Versions from './pages/Versions';
import Applications from './pages/Applications';
import ShellConsole from './pages/ShellConsole';
import Users from './pages/Users';
import ResetData from './pages/ResetData';
import './App.css';

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/devices" element={<Devices />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="/versions" element={<Versions />} />
                <Route path="/applications" element={<Applications />} />
                <Route path="/users" element={<Users />} />
                <Route path="/reset-data" element={<ResetData />} />
                <Route path="/shell/:deviceCode" element={<ShellConsole />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
